export enum LargeShareholderConnectionType {
  Company = 1,
  OpbCompany = 2,
  Director = 3
}
